<template>

<SocialLink
  icon="twitter"
  :size="size"
  :link="link"/>

</template>

<script>
import SocialLink from './SocialLink.vue'

export default {
  name: 'Twitter',
  props: {
    size: String
  },
  computed: {
    link: function() {
      return "https://www.twitter.com/quantifiedRead"
    }
  },
  components: {
    SocialLink
  }
}
</script>

<style lang="scss" scoped>
</style>
